import React from "react";
import { Avatar as AvatarMUI, Stack, Typography } from "@mui/material";

export const Avatar = ({ src = "", sx, alt = "", avatar = "", ...props }) => {
  const url = (src || avatar || "").trim();
  return (
    <AvatarMUI
      src={url}
      alt={alt}
      {...props}
      sx={{ bgcolor: "primary.main", width: 56, height: 56, ...sx }}
    >
      {alt[0]}
    </AvatarMUI>
  );
};

export const Image = ({ src, sx, alt = "alt", tipo = null, ...props }) => {
  const url = (src || "").trim();

  if (tipo === "image") {
    return (
      <img
        src={url}
        alt={alt}
        style={{ ...sx, borderRadius: "10px" }}
        {...props}
      />
    );
  }
  if (tipo === "video") {
    return (
      <video
        playsInline
        controls
        poster="/assets/poster.png"
        src={url}
        style={{ maxWidth: "100%", borderRadius: "10px" }}
      />
    );
  }

  if (tipo === "application") {
    return (
      <Stack sx={{ height: "100%", cursor: "pointer" }}>
        <Typography textAlign={"center"} fontSize={"12px"}>
          PDF {src}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ height: "100%", cursor: "pointer" }}
    >
      <Typography>File {src}</Typography>
    </Stack>
  );
};
